import { Group, Progress, Stack, Text } from "@mantine/core";

export type BarListItem = { key: string; label: string; value: number };

/** Label + count on one line, slate bar under it (canvas Ord_ReturnDash «Шалтгааны хуваарилалт»). */
export function BarList({ items }: { items: BarListItem[] }) {
  const max = Math.max(1, ...items.map((i) => i.value));
  return (
    <Stack gap="sm">
      {items.map((i) => (
        <Stack key={i.key} gap={6}>
          <Group justify="space-between" wrap="nowrap" gap="sm">
            <Text size="sm">{i.label}</Text>
            <Text size="sm" ff="monospace" style={{ fontVariantNumeric: "tabular-nums" }}>{i.value}</Text>
          </Group>
          <Progress value={(i.value / max) * 100} color="gray.7" size="md" radius="xl" aria-label={i.label} />
        </Stack>
      ))}
    </Stack>
  );
}
